<script lang="ts" setup>
import { useTranslations } from '~/composables/translations';

import type { FAQMenuContent } from '~/models/faq_models';

const props = defineProps<{
  title: string;
  content: FAQMenuContent[];
  module: string;
}>();

const emit = defineEmits(['redirectToLink']);
const { $i18n } = useTranslations(props.module);
</script>
<template>
  <div class="mpf-faq-menu flex flex-column">
    <h2 class="faq-menu-subtitle">
      {{ props.title }}
    </h2>
    <div class="faq-content">
      <div
        v-for="(item, i) in content"
        :key="`content-${i}-${item.title}`"
        class="faq-data-category"
      >
        <h3 class="faq-category-title py-10px">
          <a
            class="btn-link-icon flex grid-gap-5px"
            @click="$emit('redirectToLink', item.articles[0].url)"
          >
            <span :class="`fonticon ${item.icon}`" />
            <span class="text"> {{ $i18n(item.title) }}</span>
          </a>
        </h3>
        <div
          class="faq-articles-links grid grid-3-columns grid-2-columns--sm grid-1-columns--xs grid-gap-5px pa-15px ml-30px"
        >
          <div
            v-for="(link, j) in item.articles"
            :key="`link-${j}-${link}`"
            class="faq-article-link pointer"
          >
            <a class="text" @click="emit('redirectToLink', link.url)">
              {{ $i18n(link.title) }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.mpf-faq-menu {
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  padding: 10px 20px 40px 20px;
  background: white;
}
.faq-menu-subtitle {
  border-bottom: 1px solid #e9e9e9;
  background: white;
  font-family: '3dslight';
  margin-top: 10px;
  padding-bottom: 18px;
  text-transform: uppercase;
  position: sticky;
  top: 0;
}

.faq-category-title .btn-link-icon .text {
  font-size: 16px;
  color: #368ec4;
}

.faq-category-title .btn-link-icon .fonticon {
  font-size: 16px;
  color: #368ec4;
}

.faq-articles-links {
  background: #f9f9f9;
}
</style>
